import React, {useState} from 'react'
import styled from '@emotion/styled'

import {Box} from '@vio/atlas/helpers/Box'
import {Button} from '@vio/atlas/src/components/designSystem/Button'
import {Icon} from '@vio/atlas/src/components/designSystem/Icon'
import {useDeviceLayout} from '@vio/atlas/src/context/deviceLayout'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

const COLLAPSED_HEIGHT = 450

const ExpanderViewBox = styled.div<{isExpanded: boolean}>`
  max-height: ${({isExpanded}) =>
    isExpanded ? `auto` : `${COLLAPSED_HEIGHT}px`};
  position: relative;
  overflow: hidden;
`

const ExpanderBottomSection = styled(Box)<{isExpanded: boolean}>`
  position: ${({isExpanded}) => (isExpanded ? 'relative' : 'absolute')};
  width: 100%;
  bottom: 0;
  left: 0;
  right: 0;
`

const ExpanderBottomShade = styled.div<{isExpanded: boolean}>`
  position: absolute;
  width: 100%;
  display: ${({isExpanded}) => (isExpanded ? 'none' : 'block')};
  bottom: 0;
  left: 0;
  right: 0;
  height: 100px;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 1)
  );
`

export const AmenitiesListExpander = ({
  children,
  amenitiesAmount
}: {
  children: React.ReactNode
  amenitiesAmount: number
}) => {
  const {isMobile} = useDeviceLayout()
  const isExpandable = amenitiesAmount > 10 && isMobile
  const [isExpanded, setIsExpanded] = useState(
    !isMobile || amenitiesAmount <= 10
  )

  const onExpandClick = () => {
    setIsExpanded(!isExpanded)
  }

  return (
    <ExpanderViewBox isExpanded={isExpanded}>
      {children}
      {isExpandable && (
        <ExpanderBottomSection
          isExpanded={isExpanded}
          display="flex"
          justifyContent="center"
        >
          <ExpanderBottomShade isExpanded={isExpanded} />
          <Box paddingTop={isExpanded ? 's500' : 's000'}>
            <Button
              iconEnd={<Icon name={isExpanded ? 'ChevronUp' : 'ChevronDown'} />}
              variant="tertiary"
              onClick={onExpandClick}
            >
              {!isExpanded ? (
                <FormattedMessageWrapper
                  defaultMessage="View all amenities ({amenitiesAmount})"
                  id="roomAmenities.viewAllAmenities"
                  values={{
                    amenitiesAmount
                  }}
                />
              ) : (
                <FormattedMessageWrapper
                  defaultMessage="Show less"
                  id="showLessButton"
                />
              )}
            </Button>
          </Box>
        </ExpanderBottomSection>
      )}
    </ExpanderViewBox>
  )
}
